import { render, staticRenderFns } from "./BSPrint.vue?vue&type=template&id=04370692&scoped=true"
import script from "./BSPrint.vue?vue&type=script&lang=js"
export * from "./BSPrint.vue?vue&type=script&lang=js"
import style0 from "./BSPrint.vue?vue&type=style&index=0&id=04370692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04370692",
  null
  
)

export default component.exports